module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-top clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-middle fl"
  }, [_c('a', {
    attrs: {
      "href": "http://www.zhixinhuixue.com"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "website"
  }, [_vm._v("www.zhixinhuixue.com")]), _vm._v(" "), _c('a', {
    staticClass: "block",
    attrs: {
      "href": (_vm.baseUrl + "agreement.html"),
      "target": "_blank"
    }
  }, [_vm._v("软件使用协议")]), _vm._v(" "), _c('a', {
    staticClass: "block",
    attrs: {
      "href": (_vm.baseUrl + "version.html"),
      "target": "_blank"
    }
  }, [_vm._v("版权声明")])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "company clearfix"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v("©" + _vm._s(_vm.getYear) + " 江西风向标智能科技有限公司 All Rights Reserved")]), _vm._v(" "), _c('a', {
    staticClass: "lg-c fr",
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=36010602000036",
      "target": "_blank"
    }
  }, [_vm._v("赣公网安备36010602000036号")]), _vm._v(" "), _c('a', {
    staticClass: "fr",
    staticStyle: {
      "margin-right": "30px"
    },
    attrs: {
      "href": "http://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("赣ICP备17000955号-3 ")]), _vm._v(" "), _c('router-link', {
    staticClass: "fr",
    staticStyle: {
      "margin-right": "30px"
    },
    attrs: {
      "to": "/licence"
    }
  }, [_vm._v("增值电信业务经营许可证：赣B2-20200065")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-left fl"
  }, [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": require("../assets/img/logo2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "highlight-border"
  }, [_vm._v("公司")]), _vm._v("官网\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-right fl"
  }, [_c('p', [_c('span', {
    staticClass: "highlight-border"
  }, [_vm._v("友情")]), _vm._v("链接：")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.fxbjy.com/index"
    }
  }, [_vm._v("江西风向标智能科技有限公司")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06204e54","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 510
// module chunks = 2